import { useState, useEffect, useRef } from "react";
import carouselItem1 from "../assets/images/autostack/carousel_item_1.svg";
import carouselItem2 from "../assets/images/autostack/carousel_item_2.svg";

const AutoStackCarousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const slides = [
    {
      id: 0,
      title: "Smarter Rewards, Daily Gains",
      description:
        "Your balance increases daily as rewards are added automatically. It's a low effort way to maximize returns, even while you sleep.",
      image: carouselItem1,
    },
    {
      id: 1,
      title: "Set It and Forget It",
      description:
        "Turn it on once, and you're sorted. No need to track timers or expiry dates. Auto-Staking keeps your money moving and growing—hands-free.",
      image: carouselItem2,
    },
  ];

  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setActiveSlide((prev) => (prev + 1) % slides.length);
      }, 8000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, slides.length]);

  const handleDotClick = (index: number) => {
    setActiveSlide(index);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const currentSlide = slides[activeSlide];

  return (
    <div
      className="h-80 autostack-header-card bg-white rounded-lg p-6 flex flex-col justify-between"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-4">
        <div className="flex items-center justify-center mb-2">
          <img
            src={currentSlide.image}
            alt={currentSlide.title}
            className="w-28 lg:w-[160px]"
          />
        </div>

        <h3 className="text-lg lg:text-2xl font-semibold text-brand-primary">
          {currentSlide.title}
        </h3>

        <p className="text-sm text-gray-600 leading-relaxed max-w-lg">
          {currentSlide.description}
        </p>
      </div>

      <div className="flex justify-center space-x-2 mt-4">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`w-2 h-2 rounded-full transition-colors duration-800 ${
              index === activeSlide ? "bg-brand-light w-6" : "bg-gray-300"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AutoStackCarousel;
